module.exports = __webpack_public_path__ + "img/AV_002_logo.4a25345b.jpg";